const THEME_SWATCHES = "color-picker-theme-color-swatches";
const CUSTOM_SWATCHES = "color-picker-custom-color-swatches";
const PREDEFINED_SWATCHES = "color-picker-predefined-color-swatches";
const SWATCH = "color-picker-color-swatch";
const SWATCH_TOOLTIP = "color-picker-colors-swatch-tooltip";
const ADD_CUSTOM_COLOR_BUTTON = "color-picker-add-custom-color-button";
const FLOATING_COLOR_SWATCHES = "color-picker-floating-color-swatches";
const CUSTOM_COLOR_PICKER = "color-picker-custom-color-picker";
const RESET_BUTTON = "color-picker-reset-button";
const COLOR_PICKER_COLOR_SELECTED = "color-picker-color-selected";
const COLOR_PICKER_COLOR_ADDED = "color-picker-color-added";
const COLOR_PICKER_COLOR_PREVIEW = "color-picker-color-preview";
export {
  ADD_CUSTOM_COLOR_BUTTON,
  COLOR_PICKER_COLOR_ADDED,
  COLOR_PICKER_COLOR_PREVIEW,
  COLOR_PICKER_COLOR_SELECTED,
  CUSTOM_COLOR_PICKER,
  CUSTOM_SWATCHES,
  FLOATING_COLOR_SWATCHES,
  PREDEFINED_SWATCHES,
  RESET_BUTTON,
  SWATCH,
  SWATCH_TOOLTIP,
  THEME_SWATCHES
};
//# sourceMappingURL=data-hooks.js.map
